import { Component, Input, OnInit, Injectable, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators  } from '@angular/forms';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-learning-resources-uploads-create',
  templateUrl: './learning-resources-uploads-create.component.html',
  styleUrls: ['./learning-resources-uploads-create.component.scss']
})
export class LearningResourcesUploadsCreateComponent implements OnInit {

  constructor(private http: HttpClient, private formBuilder: FormBuilder, @Inject('API_ENDPOINT') private api_endpoint: string, private ActivatedRoute: ActivatedRoute, private router: Router,) { }

  public Form: FormGroup;
  submitted = false;
  message = null;
  class = null;
  action = null;
  mainheadings = null;

      ngOnInit() {

        this.http.get<any>(this.api_endpoint+'/learningresources').subscribe(
          data => {
            this.mainheadings = data.data
        },
        (err: HttpErrorResponse) => {
          if (err.error instanceof Error) {
            console.log("Client-side error occured.");
          } else {
            console.log("Server-side error occured.");
          }
        });

    this.Form = this.formBuilder.group({
      format: ['', Validators.required],
      contentlink: ['', Validators.required],
      heading: ['', Validators.required],
      mainheading: ['', Validators.required],
      _id: [''],
    });
    this.action = 'Submit';
    this.ActivatedRoute.params.subscribe(params => {
      let id = params['id'];
    this.http.get<any>(this.api_endpoint+'/learningresourcesuploadsbyid/' + `${id}`).subscribe(
        data => {
          if(data.data != null){
            this.action = 'Update';
            this.Form.patchValue({
              format: data.data.format,
              contentlink: data.data.contentlink,
              heading: data.data.heading,
              mainheading: data.data.mainheading,
              _id: data.data._id,
            })
            
          }else{
            this.action = 'Submit';
            this.Form.patchValue({
              format: '',
              contentlink: '',
              heading: '',
              mainheading: '',
              _id: '',
            })
          }
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log("Client-side error occured.");
        } else {
          console.log("Server-side error occured.");
        }
    });
    
  });
  }

  get f() { return this.Form.controls; }

  onFormSubmit(action){
    console.log(this.Form.value);

    this.submitted = true;
    if(action == 'Update'){
      var data = {
        "format"      : this.Form.value.format,
        "contentlink"      : this.Form.value.contentlink,
        "heading"      : this.Form.value.heading,
        "mainheading"      : this.Form.value.mainheading,
        "admin" : sessionStorage.getItem('adminName'),
        "_id"           : this.Form.value._id,
      };
      this.http.put<any>(this.api_endpoint+'/learningresourcesuploads', data).subscribe(
        res => {
          console.log(res);
          if(res.Error){
            this.message = res.Error;
            this.class = 'btn btn-primary';
            return
          }else{
            this.message = 'Successfully Updated';
            this.class = 'btn btn-success';
          } 
          this.router.navigateByUrl('/adminhkbkcms/learning-resources-uploads/list-page');
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log("Client-side error occured.");
        } else {
          console.log("Server-side error occured.");
        }
      });
    }else if(action == 'Submit'){
      var data1 = {
        "format"      : this.Form.value.format,
        "contentlink"      : this.Form.value.contentlink,
        "heading"      : this.Form.value.heading,
        "mainheading"      : this.Form.value.mainheading,
        "admin" : sessionStorage.getItem('adminName'),
      };
      this.http.post<any>(this.api_endpoint+'/learningresourcesuploads', data1).subscribe(
        res => {
          console.log(res);
          if(res.Error){
            this.message = res.Error;
            this.class = 'btn btn-primary';
            return
          }else{
            this.message = 'Successfully Added';
            this.class = 'btn btn-success';
          } 
          this.router.navigateByUrl('/adminhkbkcms/learning-resources-uploads/list-page');
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log("Client-side error occured.");
        } else {
          console.log("Server-side error occured.");
        }
      });
    }
  }

}
